import { action, payload } from 'ts-action'
import { IError, IPayload } from 'models/Global'
import { IMyUpshifter, IMyUpshiftersSortingState } from 'models/MyUpshifter'
import { ILoadingAction } from 'models/Loading'
import { IRoster } from 'models/Roster'

export const MyUpshiftersFetching = action(
  'MyUpshiftersFetching',
  payload<boolean>(),
)

export const GetMyUpshifters = action(
  'GetMyUpshifters',
  payload<IPayload<IMyUpshifter[]>>(),
)

export const GetMyUpshiftersErrors = action(
  'GetMyUpshiftersErrors',
  payload<IError>(),
)

export const DeleteFromRoster = action('DeleteFromRoster', payload<number>())

export const SetDeleteFromRosterLoading = action(
  'SetDeleteFromRosterLoading',
  payload<ILoadingAction>(),
)

export const AddToMultipleRosters = action(
  'AddToMultipleRosters',
  payload<{ upshifterId: number; rosters: IRoster[] }>(),
)

export const SetMyUpshiftersSorting = action(
  'SetMyUpshiftersSorting',
  payload<IMyUpshiftersSortingState>(),
)

export const ResetMyUpshiftersSorting = action('ResetMyUpshiftersSorting')
